import React, { useEffect, useState } from 'react';
import Header from '../Header';
import styled from 'styled-components';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import longDrink from '../../liste/longDrink.json'
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { collection, getDocs, query } from "firebase/firestore"; 
import { getFirestore } from "firebase/firestore"
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CloseIcon from '@mui/icons-material/Close';
 




const CardMenu = () => {

const db = getFirestore() 




 var settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 2,
      initialSlide: 0,
 }

     let longdrink = []
     let shortdrink = []
     let freshdrink = []
     let sansalcool = []
     let classique = []
     let mojito = []
     let vinChampagne = []
     let biereblonde = []
     let bierebrune = []
     let biereblanche = []
     let bierearom = []
     let bierepression = []
     let soft = []
     let allbiere = []
     let spiritueux = []
     let scotch = []
     let rhum = []
     let bourbon = []
     let japan = []
     let tequila = []
     let vodka = []
     let digestif = []
     let gin = []
    

     
     
  

  
    const getDataCocktail = async () => {

      
        
        const q = query(collection(db, "cocktails"));
        const querySnapshot = await getDocs(q);
        const pushArray = async () => {
            
        await querySnapshot.forEach((doc) => {
    
                switch(doc.data().type){
                  case 'vin&champagne':
                    vinChampagne.push(doc.data());
                    break;
                  case 'fresh drink': 
                  freshdrink.push(doc.data());
                  break;
                  case 'long drink':
                    longdrink.push(doc.data());
                    break;
                  case 'short drink':
                    shortdrink.push(doc.data());
                    break;
                  case 'soft':
                    soft.push(doc.data());
                    break;
                  case 'sans alcool':
                    sansalcool.push(doc.data());
                    break;
                  case 'mojito':
                    mojito.push(doc.data());
                    break;
                  case 'biere blonde':
                  biereblonde.push(doc.data());
                  break;
                  case 'biere brune':
                  bierebrune.push(doc.data());
                  break;
                  case 'biere aromatisee':
                  bierearom.push(doc.data());
                  break;
                  case 'biere blanche':
                  biereblanche.push(doc.data());
                  break;
                  case 'biere pression':
                  bierepression.push(doc.data());
                  break;
                  case 'les classiques':
                    classique.push(doc.data());
                    break;
                  case 'scotch whisky':
                  scotch.push(doc.data());
                  break;
                  case 'japan whisky':
                  japan.push(doc.data());
                  break;
                  case 'rhum':
                  rhum.push(doc.data());
                  break;
                  case 'tequila':
                  tequila.push(doc.data());
                  break;
                   case 'bourbon':
                  bourbon.push(doc.data());
                  break;
                  case 'vodka':
                  vodka.push(doc.data());
                  break;
                   case 'gin':
                  gin.push(doc.data());
                  break;
                  case 'digestif':
                  digestif.push(doc.data());
                  break;
                  default: return null;
                }
               
                
            })}   
        pushArray();
         
     
    
        allbiere = [...biereblonde, ...bierebrune, ...bierearom, ...biereblanche, ...bierepression]
        spiritueux = [...scotch,...rhum,...japan,...bourbon,...vodka,...tequila,...digestif,...gin]
        setDisplay(true)
    }
    
    getDataCocktail()
    


 

 const [menuList,setMenuList] = useState(longdrink);
 const [title,setTitle] = useState('Long Drink');
 const [valueIdTitle, setValueIdTitle] = useState('long_drink');
 const [display, setDisplay] = useState(false);
 const [modal, setModal] = useState(false);
 
  



     
  



 const handleClick = (event,tab) => {
    
    setMenuList(tab)
    setValueIdTitle(event.target.id)
    

 }

 

 useEffect(()=>{
     const titleSpliced = Object.keys(longDrink).length >= 0  && Object.keys(longDrink)?.filter((item)=> item === valueIdTitle).toString().split("_");
   
     const titleToPush = []

     if(titleSpliced.length > 1){
    titleSpliced?.map((item)=>{

    const titleJoined = item.replace(item[0],item[0].toUpperCase()).split(' ') ;
        titleToPush.push(titleJoined)
        setTitle( titleToPush.join(' '))
        
     })
     }else{
        
        const titleMin = titleSpliced.toString();
        // const titleMaj = titleMin.replace(titleMin[0],titleMin[0].toUpperCase);
        setTitle( titleMin.replace(titleMin[0], titleMin[0].toUpperCase()))
       
         
     }
           

      
     

 },[menuList])   
   

    useEffect(()=>{
      getDataCocktail();               
      
    },[]);

    const showModal = () =>{
      setModal(!modal);
    }


     

    return (
        <>
        {modal && 
        (
          <Modal>
          <div className="content">
              <img src="images/apero.jpg" alt="planche apéro" />
              <h3>Une petite faim?</h3>
              <p>Planche gourmande charcuterie, fromages, crudités</p>
              <span>Accompagné d'une sauce maison</span>
              <h3>12,50€</h3>
            <span id="back" onClick={showModal}>Retour à la carte</span>
          </div>
          
          </Modal>
        )}
        
        
        <Header/>
        <Container>
            <Caroussel {...settings}>
                
                    <Wrap  onClick={(e) => handleClick(e,longdrink)}><h4 id='long_drink'>Long Drink</h4></Wrap>
                    <Wrap onClick={(e) =>handleClick(e,freshdrink)}><h4  id='fresh_drink'>Fresh Drink</h4></Wrap>
                    <Wrap onClick={ (e) =>handleClick(e,shortdrink)}><h4  id='short_drink'>Short Drink</h4></Wrap>
                    <Wrap onClick={ (e) =>handleClick(e,classique)}><h4  id='les_classiques'>Les Classiques</h4></Wrap>                   
                    <Wrap onClick={ (e) =>handleClick(e,mojito)}><h4  id='mojitos'>Mojitos</h4></Wrap>
                    <Wrap onClick={ (e) => handleClick(e,sansalcool)}><h4  id='sans_alcool'>Sans Alcool</h4></Wrap>
                    <Wrap onClick={(e) => handleClick(e,vinChampagne)}><h4  id='vin&champagne'>Vins&Champagnes</h4></Wrap>
                    <Wrap onClick={(e) =>handleClick(e,allbiere)}><h4  id='bières'>Bières</h4></Wrap>
                    <Wrap onClick={ (e) =>handleClick(e,soft)}><h4  id='soft'>Soft</h4></Wrap>
                    <Wrap onClick={ (e) =>handleClick(e,spiritueux)}><h4  id='spiritueux'>Spiritueux</h4></Wrap>
                
            </Caroussel>
             <span id="apero" onClick={showModal}>
                      <RestaurantIcon/>
                    </span>
            <Wrapper>
           
              
                <div className="cardItem">
                    <h3>{title}</h3>
                    
                    <ul>
                      {menuList?.map((cocktail,index) => {
                          return (
                                  
                                    <li  key={index} > {cocktail.title.includes("-") ? <h4 className="type">{cocktail.title.substr(1,cocktail.title.length)}</h4> : <h4> {cocktail.title} <span id="price">{cocktail.prix.includes('€') ? cocktail.prix : (cocktail.prix !== '' ?  cocktail.prix + "€" : '' )}</span></h4>}
                                        <p>{cocktail.ingredient}  </p>

                                    </li>                     
                                    
                                    )         
                        })}
                    </ul>    
                </div>
                

              
                
                 </Wrapper>
                   
             
           
            
          <Footer>
            <ul>
              <li>Retrouvez-nous sur </li>
              <li><a href='https://www.instagram.com/lessentielbar/?hl=fr'><InstagramIcon/></a></li>
              <li><a href="https://m.facebook.com/LEssentiel-Cocktail-Bar-347876362684784/"><FacebookIcon/></a></li>
            </ul>
          </Footer>
        </Container>
        </>
    );
};


const Modal = styled.div`
display:flex;
flex-direction: column;
justify-content: flex-start;
align-items:center;
background: rgb(0,0,0,0.5);
backdrop-filter: blur(2px);
position:absolute;
height: calc(100% - 60px);
width: 100%;
z-index:5;
gap:0px;
bottom:0px;



.content{
  margin-top: 30px;
position:relative;
display:flex;
flex-direction:column;
justify-content: center;
align-items:center;
background: #333;
color: #fff;
height: 80%;
border-bottom: 2px solid #6a8e7f;
position:relative;
width: 90%;


padding: 40px 0px;
text-align:center;

img{
  
  height: 70%;
  border: #6a8e7f 2px solid;
  margin-bottom: 20px;
  
  top: 20px;
  
}

h3{
  font-weight: 500;
  font-size: 26px;
  padding: 5px 0px;
  
  font-family: 'Lobster';  
}
span{
    font-size: 14px;
    color:#6a8e7f;
  }

  
#back{

  position:absolute;
  bottom: -60px;
  right: 0px;
  padding: 5px 20px;
  color: #6a8e7f;
  font-weight: 700;
  width: auto;
  height: 40px;
  border: 1px solid black;
  display:flex;
  justify-content:center;
  align-items:center;
  background:#333;
  border-radius: 5px;
  font-size: 18px;
  
  
  
  box-shadow: 3px 5px 2px 2px rgb(0,0,0,0.5);
  z-index: 8; 
  
}
}

`


const Footer = styled.div`
position:absolute;
bottom: 40px;
width: 100%;
height: 40px;
background-color: rgb(0,0,0,0.5);
display:flex;
justify-content:center,
align-items:center;

ul{
  display:flex;
  justify-content:center;
  align-items:center;
  
  width: 100%;
  color:#a1df98;
  list-style:none;
  gap:10px;
  font-size: 14px;
  font-weight: 700;
  font-family:'Poppins';
  
  a{
    color:#a1df98;
  }
}
`

const Wrap = styled.div`

cursor: pointer;
height: 30px;
display:flex;
justify-content: center;
align-items:center;


h4{
    text-align:center;
    width: 120px;
font-family:'Lobster';
background: rgb(0,0,0,0.4);
border-radius: 4px;
color: #a1df98;
font-weight: 400;

height: 30px;
padding-top:4px;

}






`

const Caroussel = styled(Slider)`
position:relative;
margin-top: 60px;



width: 100vw;


  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 150, 171);
    }
  }
  li.slick-active button:before {
    color: white;
  }


  .slick-list {
    overflow: initial;
     box-sizing: initial;
    padding: 30px 0px;
  }
  .slick-slide {
    
    padding: 0px 20px;
  }

        

    
}


`



const Wrapper = styled.div`
width: 100vw;
height: 100%;
position:relative;

margin-top: 0px;
display:flex;
justify-content: center;


overflow: hidden;
 



.cardItem{
    position:relative;
    background: url('/images/paper.jpg');
    background-size: cover;
    width: 90%;
    display:flex;
    flex-direction:column;    
    align-items:flex-start;
    height: 80%;
    margin: 10px 10px;
    border-radius: 10px;

    #price{
      font-family: 'Lobster';
      font-size: 18px;
      font-weight: 700;
      
        color:#582900;
      padding-left: 10px;
      text-shadow: #fff 0px 0px 5px;
    }

  
    
    .type{
      font-size: 32px;
      color:#6a8e7f;
      text-shadow: 0px 0px 5px 5px rgb(0,0,0,1);
      position:relative;
      
      text-align:center;
      width: 100%;
      
      
      border-bottom: 1px rgb(0,0,0,0.3) solid;
      
      box-shadow: 0px 5px 5px 2px rgb(0,0,0,0.2);
    }

    
::-webkit-scrollbar{
    width:8px;
    display:none;
}

::-webkit-scrollbar-track:{
    background: transparent;
    display:none;

}

::-webkit-scrollbar-thumb {

  background-color: rgb(0,0,0,0.6);
  border-radius: 50px;
  display:none;
  
  
}
::-webkit-scrollbar-button{
  display:none;
}
    
   

    h3{
        font-family:'Lobster';
        font-weight: 400;
        font-size: 38px;
        color: black;
        display:block;        
        position:relative;
        top: 30px;        
        margin-bottom: 20px;    
        left: 50%;
        transform: translateX(-50%) ;
        
    }

        overflow: scroll;
  

    ul{

       display:flex;
       flex-direction: column;
       justify-content: flex-start;
       margin-top: 30px;

    
       
        
        

        li{

            height:100%;
            margin: 10px 20px;
            list-style:none;
            font-size: 18px;
            font-family:'Poppins';
            font-weight: 600;

            h4{
                font-family:'Lobster';
                font-weight: 400;
                font-size: 22px;
            }
        }

        
    }

     @media (min-width:1200px){
        
            h3{
            position:relative;
            top:50px;
            }

            ul{
                position:relative;
                top: 50px;
            }
        
    }

   
}

`

const Container = styled.div`

position:relative;
widht: 100vw;
height: 100vh;
overflow: hidden;

left:50%;
transform: translateX(-50%);
width: 90%;
height: 100vh;
display: flex;
flex-direction:column;
justify-content: center;
align-items:center;
back-drop-filter: blur(2px);

 #apero{

      position:absolute;
      top:140px;
      right:10px;
      width: 45px;
      height: 45px;
      border-radius: 32px;
      box-shadow: rgb(0,0,0,0.5) 1px 4px 5px 1px;
      z-index:2;
      display:flex;
      justify-content:center;
      align-items:center;
      background: #ccc;
      color:#6a8e7f;
      padding: 2px 2px;
      font-size: 12px;
      cursor:pointer;
    }




`

export default CardMenu;